"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/NPFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_174)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_174`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M0 0.000244141H36V23.9998H0V0.000244141Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M0 23.9998V0.000244141L19.717 12.2874H6.16008L19.0678 23.9998H0Z",
					fill: "#0052B4"
				}),
				/* @__PURE__ */ n("path", {
					d: "M17.2104 11.5703L0.717163 1.29211V23.2827H17.2104L4.30268 11.5703H17.2104Z",
					fill: "#D80027"
				}),
				/* @__PURE__ */ n("path", {
					d: "M6.89081 16.8117L5.86502 16.3291L6.41135 15.3356L5.29731 15.5487L5.15613 14.4233L4.38023 15.251L3.60426 14.4233L3.46307 15.5487L2.34911 15.3355L2.89544 16.3291L1.86951 16.8117L2.89544 17.2942L2.34911 18.2877L3.46314 18.0747L3.60426 19.2L4.38023 18.3723L5.15613 19.2L5.29731 18.0747L6.41128 18.2877L5.86502 17.2942L6.89081 16.8117ZM6.20632 7.47621L5.46016 7.12528L5.85749 6.40261L5.04728 6.55764L4.94456 5.73914L4.38023 6.34108L3.8159 5.73914L3.71324 6.55764L2.90289 6.40261L3.3003 7.12528L2.55407 7.47621L4.38023 7.84141L6.20632 7.47621Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M6.57155 7.4762C6.57155 8.68642 5.59048 9.66749 4.38026 9.66749C3.17004 9.66749 2.18896 8.68642 2.18896 7.4762",
					fill: "white"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_174`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as NPFlag };
